import { render, staticRenderFns } from "./CommunityUnitBusinessNewsDetail.vue?vue&type=template&id=6d4bd34e&scoped=true&"
import script from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=0&id=6d4bd34e&scoped=true&lang=css&"
import style1 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bd34e",
  null
  
)

export default component.exports